__turbopack_context__.v({
  "active": "style-module-scss-module__fPd6ZG__active",
  "dropdown-header": "style-module-scss-module__fPd6ZG__dropdown-header",
  "filter-dropdown": "style-module-scss-module__fPd6ZG__filter-dropdown",
  "is-commercial": "style-module-scss-module__fPd6ZG__is-commercial",
});
